import { useContext } from 'react';
import { DEFAULT_BRAND } from './../constants';
import { JucyUiProviderContext } from './JucyUiProvider';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
export const useBrand = () => useContext(JucyUiProviderContext).brand || DEFAULT_BRAND;
